import { ICountryData, ICountry, IItemTagData, IItemTag } from '@/models';
// API Data
export interface IItemData {
  item: string;
  description: string;
  unit?: string;
  abc_code?: string;
  unit_cost: number;
  family_code?: string;
  last_gen_date?: Date | string;
  is_phantom: boolean;
  price?: string | number;
  hs_code?: string;
  country_of_origin?: string | ICountryData;
  manually_created?: boolean;
  is_machine: boolean;
  invalid_item?: boolean;
  is_valid_price: boolean;
  is_obsolete: boolean;

  tags?: IItemTagData[];
}

export interface IItemFieldErrorData {
  item?: string[];
  description?: string[];
  unit?: string[];
  abc_code?: string[];
  unit_cost?: string[];
  family_code?: string[];
  last_gen_date?: string[];
  is_phantom?: string[];
  is_machine?: string[];
  price?: string[];
  hs_code?: string[];
  country_of_origin?: string[];
  is_obsolete?: string[];
  tags?: string[];
}

// Business Logic Interface
export interface IItem extends IItemData {
  price?: number;
  country_of_origin?: string | ICountry;
  tags: IItemTag[];
  validate(): boolean;
}

export interface IItemFieldError extends IItemFieldErrorData {
  clearErrors(): void;
}

export const ITEM_NUMBER_MAX_LENGTH = 32;
export const ITEM_DESCRIPTION_MAX_LENGTH = 128;
export const ITEM_UNIT_MAX_LENGTH = 3;
export const ITEM_ABC_CODE_LENGTH = 1;
export const ITEM_FAMILY_CODE_MAX_LENGTH = 20;
// Constants - Used for validation
